import { getQueryStringParameter, clearInputField } from '../../../helpers';

const toggleOtherField = ($otherOriginButtons, $otherField) => {
  $otherOriginButtons.on('change', (e) => {
    if (e.target.checked) {
      $otherField.removeClass('d-none');
    } else {
      clearInputField($('input', $otherField)[0]);
      $otherField.addClass('d-none');
    }
  })
};

$(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'financial_situation') {
    return;
  }

  const $otherOriginOfInvestedFundsOther = $('#users_profile_natural_origin_of_invested_funds_other', $form);
  const $otherOriginOfInvestedFundsField = $('#other_origin_of_invested_funds_field', $form);

  const $otherOriginOfIncomeOther = $('#users_profile_natural_origin_of_income_other', $form);
  const $otherOriginOfIncomeField = $('#other_origin_of_income_field', $form);

  const $otherOriginOfAssetsOther = $('#users_profile_natural_origin_of_assets_other', $form);
  const $otherOriginOfAssetsField = $('#other_origin_of_assets_field', $form);

  toggleOtherField($otherOriginOfInvestedFundsOther, $otherOriginOfInvestedFundsField);
  toggleOtherField($otherOriginOfIncomeOther, $otherOriginOfIncomeField);
  toggleOtherField($otherOriginOfAssetsOther, $otherOriginOfAssetsField);
});
